import { type FC, useState } from "react";
import { Col, Row } from "../../common/components/Layout";
import GridGappedContainer, {
  GridGappedContainerSize,
} from "../../common/components/GridGappedContainer/GridGappedContainer";
import { CloseBtn } from "../../AddToCart/components/addToCart/AtcCloseButton";

import Modal from "../../common/components/Modal";
import { type SavedConfiguration } from "../Linear/models";
import { useForm } from "react-hook-form";
import ShareConfigurationsViaEmailPopupForm from "./ShareConfigurationsViaEmailPopupForm";
import { sendLinearConfigurationsViaEmail } from "../Linear/api/ShareConfigurationsViaEmail";
import FullscreenLoader from "../../common/components/FullscreenLoader";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import { submitAsForm } from "../../api/ApiHelper";
import { Button } from "~/common/components/Button/Button";
import { useTranslation } from "react-i18next";
import { Stacker } from "~/common/components/Stacker/Stacker";

interface Props {
  onClose: () => void;
  items: SavedConfiguration[];
  onSuccess: () => void;
}

const ShareConfigurationsViaEmailPopup: FC<Props> = ({ onClose, items, onSuccess }) => {
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm();
  const [isFormLoading, setIsFormLoading] = useState(false);

  const onSubmitHandler = handleSubmit((values) => {
    const sharedConfigurations = items.map((item) => item.code);
    const email = values.email;
    const consent = values.consent;
    if (email && consent) {
      setIsFormLoading(true);
      sendLinearConfigurationsViaEmail({
        sharedConfigurations,
        email: email,
        firstName: values.firstName,
        lastName: values.lastName,
        note: values.note,
      })
        .then((result) => {
          if (result.error) {
            setError("email", { message: result.error });
          } else {
            const confirmationUrl = resolveApiUrl("/sendLinearConfigurationsViaEmail/confirmation");
            const confirmationData = {
              configurations: JSON.stringify(sharedConfigurations),
            };
            submitAsForm(confirmationData, confirmationUrl);
          }
        })
        .catch(() => setIsFormLoading(false));
    }
  });

  if (isFormLoading) {
    return <FullscreenLoader />;
  }

  return (
    <Modal
      onClose={onClose}
      title={t("page.savedConfigsPopup.shareViaEmail.configurations", { count: items.length })}
      footerChildren={
        <Row className={"d-flex flex-justify-between flex-align-center w-100"}>
          <p>{t("mandatory")}</p>
          <Stacker direction={"row"} gap={8}>
            <CloseBtn onClick={onClose}>{t("cancel")}</CloseBtn>
            <Button onClick={onSubmitHandler}>{t("page.savedConfigsPopup.shareViaEmail.send")}</Button>
          </Stacker>
        </Row>
      }
    >
      <Row>
        <Col size={12}>
          <ShareConfigurationsViaEmailPopupForm register={register} control={control} errors={errors} />
        </Col>
      </Row>
    </Modal>
  );
};

export default ShareConfigurationsViaEmailPopup;
